import { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import {
  notificationSettingsState,
  defaultNotificationSettings,
} from '@atom/setting/notification';
import { fuego } from '@store/firebase/index';

/**
 * 로그인 시 Firestore users/{uid}.notificationSettings 읽어서 atom에 동기화,
 * 로그아웃 시 defaultSettings로 리셋합니다.
 * 앱 최상단에서 1회만 마운트하세요.
 */
export function useNotificationSync() {
  const [, setSettings] = useRecoilState(notificationSettingsState);

  useEffect(() => {
    const unsubscribe = fuego.auth().onAuthStateChanged(async (user) => {
      if (user) {
        try {
          const snap = await fuego.db.collection('users').doc(user.uid).get();
          const saved = snap.data()?.notificationSettings;
          if (saved) {
            setSettings({ ...defaultNotificationSettings, ...saved });
          }
        } catch {
          // Firestore 읽기 실패 시 localStorage 값 그대로 유지
        }
      } else {
        // 로그아웃 시 기본값으로 리셋
        setSettings(defaultNotificationSettings);
      }
    });

    return () => unsubscribe();
  }, [setSettings]);
}
